module.exports = __webpack_public_path__ + "static/media/notstarted.aeed3736.png";